module.exports = __webpack_public_path__ + "static/media/profile-pic-edit.ab890178.svg";